const COST_CENTER_RENAME_COMPANY = '旭化成塑料';

const COST_CENTER_I18N_KEY_MAP = {
    'statistics.costcenter': 'statistics.expenseDepartment',
    'statistics.selectcostcenter': 'statistics.selectExpenseDepartment',
    'statistics.costpaysort': 'statistics.expenseDepartmentRanking',
    'order.costcenter': 'order.expenseDepartment',
    'system.costcenters': 'system.expenseDepartments',
    'mall.costcenter': 'mall.expenseDepartment',
    'bill.costcenter': 'bill.expenseDepartment',
    'bill.costcenternamesearch': 'bill.expenseDepartmentNameSearch',
    'bill.receivetablefaila': 'bill.selectExpenseDepartment',
    'webdata.costcenter': 'webdata.expenseDepartment',
    'category.CostCenter': 'category.ExpenseDepartment',
    'mall.xiaofeijineshangxian': 'mall.dangdizhusubiaozhunshangxian'
};

function isCostCenterRenameCompany(store) {
    let ticketInfo = store.getters.ticketInfo || {};
    return ticketInfo.CompanyName && ticketInfo.CompanyName.indexOf(COST_CENTER_RENAME_COMPANY) > -1;
}

function costCenterI18nKey(key, store) {
    if (!isCostCenterRenameCompany(store) || typeof key !== 'string') {
        return key;
    }
    return COST_CENTER_I18N_KEY_MAP[key] || key;
}

function costCenterText(value, store) {
    if (!isCostCenterRenameCompany(store) || typeof value !== 'string') {
        return value;
    }
    return value
        .replace(/成本名称搜索/g, '费用负担部门名称搜索')
        .replace(/成本中心/g, '费用负担部门')
        .replace(/消费金额/g, '当地住宿费标准');
}

export default function installCostCenterI18n(Vue, i18n, store) {
    const i18nT = i18n._t.bind(i18n);
    i18n._t = function () {
        let args = Array.prototype.slice.call(arguments);
        args[0] = costCenterI18nKey(args[0], store);
        return i18nT.apply(i18n, args);
    }
    Vue.prototype.$costCenterText = function (value) {
        return costCenterText(value, store);
    }
}



// WEBPACK FOOTER //
// ./src/utils/costCenterI18n.js